import { Box, capitalize, Link as MUILink, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { useEasierTheme } from "datalign-themes";
import React from "react";

const BaseBreadcrumb = ({
  domain,
  datatype,
  group,
  input,
}: {
  domain: string | null;
  datatype: string | null;
  group: string | null;
  input?: string | null;
}) => {
  const theme = useEasierTheme();

  return (
    <Box
      mt={1}
      p={1}
      sx={{
        borderRadius: "24px",
        display: "flex",
        justifyContent: "center",
        outline: "none",
        background: "#fff",
        border: "1px solid #ddd",
        maxWidth: "95vw",
      }}
    >
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={
          <Typography
            sx={{
              color: theme?.Colour.Secondary(),
            }}
          >
            {">"}
          </Typography>
        }
        sx={{
          borderRadius: "12px",
        }}
      >
        <MUILink
          component={RouterLink}
          to="/"
          underline="hover"
          sx={{
            wordWrap: "break-word",
          }}
        >
          Home
        </MUILink>
        {domain && (
          <MUILink
            component={RouterLink}
            to={`/search?Domains=${domain}`}
            underline="hover"
            sx={{
              wordWrap: "break-word",
            }}
          >
            {capitalize(domain)}
          </MUILink>
        )}
        {datatype && (
          <MUILink
            component={RouterLink}
            to={`/search?Datatypes=${datatype}`}
            underline="hover"
            sx={{
              wordWrap: "break-word",
            }}
          >
            {capitalize(datatype)}
          </MUILink>
        )}
        {group && (
          <MUILink
            component={RouterLink}
            to={`/search?Groups=${group}`}
            underline="hover"
            sx={{
              wordWrap: "break-word",
            }}
          >
            {capitalize(group)}
          </MUILink>
        )}
        {input && <Typography>{input}</Typography>}
      </Breadcrumbs>
    </Box>
  );
};

export default BaseBreadcrumb;
